"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ModalBody: true,
  ModalHeader: true
};
Object.defineProperty(exports, "ModalBody", {
  enumerable: true,
  get: function get() {
    return _Body.Body;
  }
});
Object.defineProperty(exports, "ModalHeader", {
  enumerable: true,
  get: function get() {
    return _Header.Header;
  }
});
var _Modal = require("./Modal");
Object.keys(_Modal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Modal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Modal[key];
    }
  });
});
var _Body = require("./Body");
var _Header = require("./Header");